export var valuesGameState = ["Unfinished", "Finished", "All"];
/*

*/ 
//# sourceMappingURL=GameState.js.map